import { loadStripe } from '@stripe/stripe-js';

export const ActivateStripe = async (props) => {
  const { publicKey } = props;

  return await loadStripe('pk_test_51GsPpTB6ywDuU6ayYoPmXYTulNuL46z62cNNTKdBa4xjDPQPOY6rIN990aTMlbRGgTGAX0CQtSz8pe9aYT6jOy0h00GmfiCoof');

  // return new Promise((resolve, reject) => {
  //   const elements = Stripe.elements();
  //
  //   const cardNumber = elements.create('cardNumber');
  //
  //   const cardExpiry = elements.create('cardExpiry');
  //
  //   const cardCvc = elements.create('cardCvc');
  //
  //   // const cardNumberElement = elements.create('cardNumber', {
  //   //   style
  //   // });
  //
  //   // cardNumberElement.mount('#card-number-element');
  //
  //   // cardNumber.mount('#cardNumber');
  //   // cardExpiry.mount('#cardExpiry');
  //   // cardCvc.mount('#cardCvc');
  //
  //   // const cardNumber = {
  //   //   cardNumber: card.number
  //   // };
  //   //
  //   // const cardExpiry = {
  //   //   cardExpiry: card.exp
  //   // };
  //   //
  //   // const cardCvc = {
  //   //   cardCvc: card.cvc
  //   // };
  //
  //   Stripe.createToken().then((status, response) => {
  //       if (response.error) {
  //           const error = response.error;
  //
  //           if (error.type === 'invalid_request_error') {
  //             console.log(response.error.message);
  //               // app.$alert.error(response.error.message);
  //           } else {
  //             console.log(response.error.message);
  //               // app.$alert.error(response.error.message);
  //           }
  //
  //           console.log('Error');
  //
  //           reject();
  //       } else {
  //         console.log('Success');
  //
  //         resolve(response);
  //       }
  //   });
  // });
};

// export default ActivateStripe;
